/*
 * @Author: 张天昊
 * @Date: 2024-11-13 10:55:04
 * @LastEditTime: 2024-11-15 14:16:32
 * @LastEditors: 张天昊
 * @Description:
 * @FilePath: /Mobile/src/store/modules/privacy.js
 */
import { getPrivacyCollectionInfo } from "@/service";

const hp_compare = (propName) => {
  return function (a, b) {
    var valueA = a[propName];
    var valueB = b[propName];
    return valueA - valueB;
  };
};
const hp_buildInfoList = (originData) => {
  var tempArray = Object.entries(originData);
  var newArray = [];

  // 重新构建数据结构 - 从dictionary转为array
  for (let index = 0; index < tempArray.length; index++) {
    const element = tempArray[index];
    var key = element[0];
    var value = element[1];
    value.key = key;
    newArray.push(element[1]);
    // 内部的fields排序
    value.fields = value.fields.sort(hp_compare('sort'));

    for (let j = 0; j < value.fields.length; j++) {
      const fieldsElement = value.fields[j];
      // 外部有URL时item就不会有URL 需要把外部的URL塞到内部每个item中
      if (value.url && value.url.length > 0) {
        fieldsElement.url = value.url;
        fieldsElement.displayContent = '查看详情';
      } else {
        // 特殊处理value为数组的情况
        if (Array.isArray(fieldsElement.value)) {
          // value为数组说明是第三方登录的unionId 组装一下显示内容
          var displayContent = '';
          for (let k = 0; k < fieldsElement.value.length; k++) {
            const valueElement = fieldsElement.value[k];
            displayContent =
              valueElement.name + ' union id ' + valueElement.value.unionId;
            if (k !== 0) {
              displayContent = displayContent + '\n';
            }
          }
          fieldsElement.displayContent = displayContent;
        } else {
          if (fieldsElement.url && fieldsElement.url.length > 0) {
            fieldsElement.displayContent = '查看详情';
          } else {
            fieldsElement.displayContent = fieldsElement.value;
          }
        }
      }
    }
  }

  newArray = newArray.sort(hp_compare('sort'));
  console.log('----- final array', newArray);

  return newArray;
};
export default {
  namespaced: true,
  state() {
    return {
      infoListData: []
    };
  },
  mutations: {
    SET_PRIVACY_INFO_DATA(state, param) {
      state.infoListData = param;
    }
  },
  actions: {
    async fetchPrivacyPageInfo({ commit }) {
      // Loading();
      try {
        // let paramDict = { type: type };
        let res = await getPrivacyCollectionInfo();
        if (res.ret === 0) {
          let finalList = hp_buildInfoList(res.data);
          commit('SET_PRIVACY_INFO_DATA', finalList);
        }
      } catch (e) {
        console.log(e);
      } finally {
        // Loading.close();
      }
    }
  }
};
